import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import FormGroup from '@material-ui/core/FormGroup';

import { ItemizedPlanSelector } from './itemized-plan-selector';
import { billingInfoForAccountIdSelector } from '../../account-selectors';
import { getBillingInfo } from '../../actions/get-billing-info';

import { UiDialog } from '../../../ui/ui-dialog';

type InputProps = AccountStatusTransitionDialogProps & {
  isEdit?: boolean;
};

const mapStateToProps = (state: any, { account }: InputProps) => ({
  billingInfo: billingInfoForAccountIdSelector(state, account.accountId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { account }: InputProps,
) => ({
  actions: {
    loadBillingInfo: () => dispatch(getBillingInfo(account.accountId)),
  },
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const ItemizedPlanConfirmationDialogBody = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  const { account, isEdit, cancelTransition, handleTransitionConfirmed, billingInfo, actions } =
    props;

  useEffect(() => {
    actions.loadBillingInfo();
  });

  return (
    <UiDialog.Content>
      <FormGroup>
        <ItemizedPlanSelector
          account={account}
          onClose={cancelTransition}
          subscriptionPriceItems={billingInfo?.subscriptionPriceItems || []}
          handleTransitionConfirmed={handleTransitionConfirmed}
          fromStatusTransition
          isEdit={isEdit}
        />
      </FormGroup>
    </UiDialog.Content>
  );
});
